/**
 * Whether `url` is an absolute `https:` URL. Hub-provided signed URLs (report downloads, resource and
 * certificate files) are always https; anything else (`javascript:`, `data:`, `http:`, relative) is refused.
 */
export function isHttpsUrl(url: string | null | undefined): url is string {
  if (typeof url !== 'string') {
    return false;
  }
  try {
    return new URL(url).protocol === 'https:';
  } catch {
    return false;
  }
}

/**
 * Opens a hub-provided URL in a new tab with no opener or referrer. Opens nothing and returns `false` unless
 * the URL is `https:`.
 */
export function openExternal(url: string): boolean {
  if (!isHttpsUrl(url)) {
    return false;
  }
  window.open(url, '_blank', 'noopener,noreferrer');
  return true;
}
